import type { CoverNoteData } from '../types/coverNote';

const MOCK_QR =
  'iVBORw0KGgoAAAANSUhEUgAAAAEAAAABCAYAAAAfFcSJAAAADUlEQVR42mP8z8BQDwAEhQGAhKmMIQAAAABJRU5ErkJggg==';

function baseWp112(caseRequestId: string): CoverNoteData {
  return {
    caseRequestId,
    fileReferenceNumber: 'WP1/112/2026',
    requestSubmittedAt: '2026-03-22T10:04:00',
    submittedAgency: 'Child Authority Service',
    fileCategory: 'Criminal Division',
    subFileCategory: 'CH - Child Abuse',
    caseSource: 'National Child Protection Authority (NCPA)',
    connectedAgdFileReferenceNumber: 'WP1/100/2025',
    accusedOrSuspectName: 'Kamal Perera (Remanded)',
    applicableAreas: 'Statutory Rape, Sexual Harassment, Kidnapping, Cruelty to Children',
    description:
      'This case involves multiple allegations of severe child abuse requiring immediate legal intervention. Comprehensive medical and police reports have been attached for review.',
    urgencyLevel: 'High',
    deadline: '2026-03-30',
    urgencyJustification:
      'The suspect is highly likely to abscond and the victim is at imminent risk. Prompt processing is strictly crucial.',
    documents: ['1. B Report', '2. IB Extracts', '3. Birth Certificate', '4. MLR', '5. Government Analyst Report'],
    qr: MOCK_QR,
  };
}

/** Mock cover notes keyed by file reference — replace with API when integrated. */
export const coverNoteByFileRef: Record<string, CoverNoteData> = {
  'WP1/112/2026': baseWp112('cr-wp1-112-2026'),
  'E/104/2026/AGD': {
    caseRequestId: 'cr-e-104-2026',
    fileReferenceNumber: 'E/104/2026/AGD',
    requestSubmittedAt: '2026-03-20T14:30:00',
    submittedAgency: 'Department of Land Settlement',
    fileCategory: 'Civil Division - Advise',
    subFileCategory: 'E - General Legal Advice',
    caseSource: 'Department of Land Settlement',
    connectedAgdFileReferenceNumber: '—',
    accusedOrSuspectName: '—',
    applicableAreas: 'Land settlement, Title disputes',
    description: 'Request for legal advice on land settlement matter involving multiple claimants.',
    urgencyLevel: 'Normal',
    deadline: '2026-04-15',
    urgencyJustification: '—',
    documents: ['1. Land settlement documents', '2. Survey plans'],
    qr: MOCK_QR,
  },
  'COA/088/2026': {
    caseRequestId: 'cr-coa-088-2026',
    fileReferenceNumber: 'COA/088/2026',
    requestSubmittedAt: '2026-02-28T11:20:00',
    submittedAgency: 'Sri Lanka Police',
    fileCategory: 'Civil Appellate Division',
    subFileCategory: 'COA - Court of Appeal',
    caseSource: 'Sri Lanka Police',
    connectedAgdFileReferenceNumber: '—',
    accusedOrSuspectName: '—',
    applicableAreas: 'Appeal, Civil procedure',
    description: 'Appeal matter referred for legal opinion on procedural compliance.',
    urgencyLevel: 'Normal',
    deadline: '2026-05-01',
    urgencyJustification: '—',
    documents: ['1. Court of Appeal papers', '2. Lower court record'],
    qr: MOCK_QR,
  },
  'MP/009/2026': {
    caseRequestId: 'cr-mp-009-2026',
    fileReferenceNumber: 'MP/009/2026',
    requestSubmittedAt: '2026-01-18T14:00:00',
    submittedAgency: 'Ministry of Health',
    fileCategory: 'Public Petitions',
    subFileCategory: '—',
    caseSource: 'Ministry of Health',
    connectedAgdFileReferenceNumber: '—',
    accusedOrSuspectName: '—',
    applicableAreas: 'Public Petition',
    description: 'Public petition regarding health service delivery in regional hospitals.',
    urgencyLevel: 'Normal',
    deadline: '2026-05-01',
    urgencyJustification: '—',
    documents: ['1. Petition Letter', '2. Supporting Documents'],
    qr: MOCK_QR,
  },
  'E/200/2026/AGD': {
    caseRequestId: 'mock-e-200-2026',
    fileReferenceNumber: 'E/200/2026/AGD',
    requestSubmittedAt: '2026-02-28T11:20:00',
    submittedAgency: 'Sri Lanka Police',
    fileCategory: 'Civil Appellate Division',
    subFileCategory: 'COA - Court of Appeal',
    caseSource: 'Sri Lanka Police',
    connectedAgdFileReferenceNumber: '—',
    accusedOrSuspectName: '—',
    applicableAreas: 'Appeal, Civil procedure',
    description: 'Appeal matter referred for legal opinion on procedural compliance.',
    urgencyLevel: 'Normal',
    deadline: '2026-05-01',
    urgencyJustification: '—',
    documents: ['1. Court of Appeal papers', '2. Lower court record'],
    qr: MOCK_QR,
  },
  'PP/05/2026/AGD': {
    caseRequestId: 'mock-pp-05-2026',
    fileReferenceNumber: 'PP/05/2026/AGD',
    requestSubmittedAt: '2026-01-18T14:00:00',
    submittedAgency: 'Ministry of Health',
    fileCategory: 'Public Petitions',
    subFileCategory: '—',
    caseSource: 'Ministry of Health',
    connectedAgdFileReferenceNumber: '—',
    accusedOrSuspectName: '—',
    applicableAreas: 'Public Petition',
    description: 'Public petition regarding health service delivery in regional hospitals.',
    urgencyLevel: 'Normal',
    deadline: '2026-05-01',
    urgencyJustification: '—',
    documents: ['1. Petition Letter', '2. Supporting Documents'],
    qr: MOCK_QR,
  },
  'RTI/12/2026/AGD': {
    caseRequestId: 'mock-rti-12-2026',
    fileReferenceNumber: 'RTI/12/2026/AGD',
    requestSubmittedAt: '2026-04-01T09:00:00',
    submittedAgency: 'Ministry of Education',
    fileCategory: 'Right to Information',
    subFileCategory: '—',
    caseSource: 'Ministry of Education',
    connectedAgdFileReferenceNumber: '—',
    accusedOrSuspectName: '—',
    applicableAreas: 'Right to Information Act',
    description: 'RTI appeal regarding refusal to release education sector records.',
    urgencyLevel: 'Normal',
    deadline: '2026-06-01',
    urgencyJustification: '—',
    documents: ['1. RTI application', '2. Appeal letter'],
    qr: MOCK_QR,
  },
  'RTI/021/2026': {
    caseRequestId: 'cr-rti-021-2026',
    fileReferenceNumber: 'RTI/021/2026',
    requestSubmittedAt: '2026-04-01T09:00:00',
    submittedAgency: 'Department of Land Settlement',
    fileCategory: 'Right to Information',
    subFileCategory: '—',
    caseSource: 'Department of Land Settlement',
    connectedAgdFileReferenceNumber: '—',
    accusedOrSuspectName: '—',
    applicableAreas: 'Right to Information Act',
    description: 'RTI appeal regarding refusal to release land acquisition records.',
    urgencyLevel: 'Normal',
    deadline: '2026-06-01',
    urgencyJustification: '—',
    documents: ['1. RTI application', '2. Appeal letter'],
    qr: MOCK_QR,
  },
};

export function getMockCoverNote(fileRef: string, caseRequestId?: string): CoverNoteData | null {
  const key = fileRef.trim();
  const found = coverNoteByFileRef[key];
  if (!found) return null;
  return { ...found, caseRequestId: caseRequestId ?? found.caseRequestId };
}
